
(function () {
    document.querySelectorAll('.page-content').forEach(function(content) {
        content.querySelectorAll('a').forEach((a) => {
            if (a.hasAttribute('href')) {
                const src = a.getAttribute('href');
                if (src) {
                    const ext = src.split('/[#?]/')[0].split('.').pop().trim();
                    if (ext && ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'csv'].includes(ext)) {
                        a.classList.add(`${ext}-file`);
                        a.classList.add('document-file');
                        a.innerHTML = `<span>${ext}</span>` + a.innerHTML;
                    }
                }
            }
        });
    });
}());